export default {
    ResponseActions: {
        displayFeedbackPanes: {
            actionName: "DisplayForm",
        },
        getConversationTranscript:{
            actionName: "GetConversationTranscript",
        },
        webMessagingResponseHandler:
        {
            actionName: "LaunchWebMessenger",
        },
    },
};


// WEBPACK FOOTER //
// ./settings/response-actions.ts